export default "__VITE_ASSET__M$tBqUqk__"